module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/housekeeping/css/reset-password.component.css
// module id = ./src/app/modules/housekeeping/css/reset-password.component.css
// module chunks = main